import { styled } from "goober";
import { Icon, type Size } from "./Icon";

const IconSlot = styled("span")`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transform: rotate(-180deg) scale(0.5);
  transition:
    opacity 0.15s ease-out,
    transform 0.2s ease-out;
`;

const Wrap = styled("span")`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  color: var(--text-secondary);

  > ${IconSlot}[data-icon="copy"] {
    opacity: 1;
    transform: rotate(0) scale(1);
  }
  &[data-state="cmd"] > ${IconSlot}[data-icon="copy"] {
    opacity: 0;
    transform: rotate(180deg) scale(0.5);
  }
  &[data-state="cmd"] > ${IconSlot}[data-icon="open"] {
    opacity: 1;
    transform: rotate(0) scale(1);
  }
  &[data-state="copied"] > ${IconSlot}[data-icon="copy"] {
    opacity: 0;
    transform: rotate(90deg) scale(0.5);
  }
  &[data-state="copied"] > ${IconSlot}[data-icon="check"] {
    opacity: 1;
    transform: rotate(0) scale(1);
  }
`;

export function CopyOpenIcon({
  state,
  size = 10,
}: {
  state?: "cmd" | "copied";
  size?: Size;
}) {
  return (
    <Wrap data-state={state} style={{ width: size, height: size }}>
      <IconSlot data-icon="copy">
        <Icon name="copy" size={size} />
      </IconSlot>
      <IconSlot data-icon="open">
        <Icon name="arrow-up-right" size={size} />
      </IconSlot>
      <IconSlot data-icon="check">
        <Icon name="check" size={size} />
      </IconSlot>
    </Wrap>
  );
}
